import React from 'react';
// import {ReactComponent as EditIcon} from '../../../../../../../assets/main/groups/main-top/edit.svg';
import {ReactComponent as StatArrayIcon} from '../../../../../../../assets/main/groups/students/statistic-array.svg';
import {ReactComponent as StatArrayIcon2} from '../../../../../../../assets/main/groups/students/statistic2-array.svg';
import {ReactComponent as SCloseIcon} from '../../../../../../../assets/main/groups/students/statistic/SCloseIcon.svg';
import {
    ReactComponent as SFulfilledIcon
} from '../../../../../../../assets/main/groups/students/statistic/SFulfilledIcon.svg';
import {
    ReactComponent as SBurgerIcon
} from '../../../../../../../assets/main/groups/students/statistic/SBurgerIcon.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setLanguageLevelAC} from "app/popups-reducer";
import {Link} from "react-router-dom";
import {RadialStatisticItem} from "./radial-statisti-item-block/RadialStatisticItem";
import {CefrLevelsComponent} from "./cefr-levels-component/CefrLevelsComponent";


export const StudentsStatistic = () => {
    const isLanguageLevel = useAppSelector((state) => state.popups.isLanguageLevel);
    const dispatch = useAppDispatch()
    const arrowIcon1 = <StatArrayIcon/>;
    const arrowIcon2 = <StatArrayIcon2/>;

    const student = useAppSelector((state) => state.studentInfo.data);


    const beginLanguageLevel = student?.beginLanguageLevel
    const currentLanguageLevel = student?.currentLanguageLevel


    const onClickHandler = () => {
        dispatch(setLanguageLevelAC(!isLanguageLevel))
    }


    return (
        <>
            {student && (
                <div className="person-data-box" key={student.id}>
                    <div className="person-data-col">
                        <div className="person-avatar-box">
                            <div className="person-avatar avatar">
                                <img src={student.avatar} alt=""/>
                            </div>
                        </div>
                        <div className="person-data">
                            <p className="h3 person-name">{student.fullName}</p>
                            <ul className="person-description-list">
                                {student.group && (
                                    <li>
                                        <Link to={`/groups/${student.group.id}`}>{student.group.title}</Link>
                                    </li>
                                )}
                                {student?.corporateClient && (
                                    <>
                                        <span className="separator">/</span>
                                        <li>{student.corporateClient}</li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="person-statistic-col">
                        <div className="person-statistic">
                            <div className="cefr-levels-box">
                                <CefrLevelsComponent
                                    beginLanguageLevel={beginLanguageLevel}
                                    currentLanguageLevel={currentLanguageLevel}
                                    onClickHandler={onClickHandler}
                                    editVisible={true}
                                    arrowIcon1={arrowIcon1}
                                    arrowIcon2={arrowIcon2}
                                />

                            </div>
                            {student.cuts !== null || student.efficiency !== null ? (
                                <div className="radial-statistic-box">
                                    {student.cuts !== null && (
                                        <RadialStatisticItem
                                            label="Срезы"
                                            value={student.cuts}
                                            gradientId="linearColorsSrez"
                                            id="srezProgress"
                                        />
                                    )}
                                    {student.efficiency !== null && (
                                        <RadialStatisticItem
                                            label="Эффективность"
                                            value={student.efficiency}
                                            gradientId="linearColorsEfficiency"
                                            id="efficiencyProgress"
                                        />
                                    )}
                                </div>
                            ) : null}

                        </div>
                    </div>
                </div>
            )}

            <div className="cards-statistic-box">
                <div className="card-statistic-item">
                     <span className="icon">
                        <SFulfilledIcon/>
                    </span>
                    <p className="title h5">Посещенные занятия</p>
                    <span className="num h3">{student?.attendedLessons}</span>
                </div>
                <div className="card-statistic-item">
                    <span className="icon">
                        <SCloseIcon/>
                    </span>
                    <p className="title h5">Пропуски</p>
                    <span className="num h3">{student?.missedLessons}</span>
                </div>
                <div className="card-statistic-item">
                    <span className="icon">
                        <SBurgerIcon/>
                    </span>
                    <p className="title h5">Домашние задания</p>
                    <span className="num h3">
                            {student?.homeworksDone}
                        <span className="h4">/{student?.homeworksAll}</span>
                    </span>
                </div>
            </div>
        </>
    );
};
